export * from './PacmanLoader.js';
